/* eslint-disable brace-style */
import runtime from "art-template/lib/runtime";
import "./index.less";
import OYTool from "./components/OYTool";
// import OYSearch from './components/OYSearch';
import OYFilter from "./components/OYFilter";
import OYOrderBar from "./components/OYOrderBar";
import OYIndustryComponet from "./components/OYIndustryComponet";
import OYSpecification from "./components/OYFilter/components/OYSpecification";
import OYButton from "./components/OYButton";
import OYInputRange from "./components/OYInputRange";
import OYSelect from "./components/OYSelect";
import OYRadio from "./components/OYRadio";
import OYCheckbox from "./components/OYCheckbox";
import OYInput from "./components/OYInput";
import OYDatePicker from "./components/OYDatePicker";
import OYRadioCheckbox from "./components/OYRadioCheckbox";
import OYProductType from "./components/OYFilter/components/OYProductType";
import OYFilterBarChannel from "./components/OYFilterBar/components/OYFilterBarChannel";

import { isObject, isArray, classnames, valueIncludes, industryComponetInclueds, containsObject } from './utils';
import OYBalanceWeight from './components/OYFilter/components/OYBalanceWeight';
import OYFlag from './components/OYFilter/components/OYFlag';
import OYDropdownInput from './components/OYDropdownInput';
import OYDropdownInputRange from './components/OYDropdownInputRange';
import OYProductProp from './components/OYFilter/components/OYProductProp';
import OYFilterBar from './components/OYFilterBar';
import OYTag from './components/OYTag';
import OYTab from './components/OYTab';
import OYCategoryTab from './components/OYCategoryTab';
import OYCheckbox2 from './components/OYCheckbox2';
import OYFilterBarSaveList from './components/OYFilterBar/components/OYFilterBarSaveList';

if (typeof jQuery === 'undefined') {
    throw new Error('can not find jQuery');
}

//  模板函数绑定
runtime.isArrary = isArray;
runtime.isObject = isObject;
runtime.classnames = classnames;
runtime.styles = OYTool.styles;
runtime.valueIncludes = valueIncludes;
runtime.encode = window.encodeURIComponent;
runtime.industryComponetInclueds = industryComponetInclueds;
runtime.containsObject = containsObject;

runtime.maxLength = function (value: string, length = 50) {
    if (value && value.length > length) {
        return value.slice(0, length - 1) + '...'
    }
    return value;
}

$.extend({
    OYTool
});
// Jquery插件函数绑定
[
    OYFilter,
    OYOrderBar,
    OYFilterBar,
    OYIndustryComponet,
    OYTab,
    OYTag,
    OYButton,
    OYInput,
    OYInputRange,
    OYSelect,
    OYCheckbox,
    OYCheckbox2,
    OYRadio,
    OYDatePicker,
    OYRadioCheckbox,
    OYDropdownInput,
    OYDropdownInputRange,
    OYCategoryTab,
    OYFilterBarSaveList,
    OYFilterBarChannel,
    OYSpecification,
    OYBalanceWeight,
    OYFlag,
    OYProductProp,
    OYProductType,
 ].forEach((Component: any) => {
  $.fn[Component.displayName] = function (option: any = {}) {
    if (!this.length) {
      // return console.error(`${Component.displayName} - Dom not Find`);
      return;
    }

    let filterOption: any = { $parent: this };
    filterOption = Object.keys(option).reduce((pre, key) => {
      const value = option[key];
      if (value !== undefined && value !== null) {
        pre[key] = value;
      }
      return pre;
    }, filterOption);
    return new Component(filterOption);
  };
});



// WEBPACK FOOTER //
// ./src/index.ts